module.exports = __webpack_public_path__ + "static/media/11.8dc1d967.jpg";